module.exports = __webpack_public_path__ + "static/media/customcare.c2f1a8d6.png";